module.exports = __webpack_public_path__ + "static/media/deal.4c6dd1c8.svg";